import { connect } from "react-redux";
import ViewDetails from "./viewDetails";
import { bindActionCreators } from "redux";
import { getDetails } from "services/redux/sales/preSaleListing/action"
const mapStateToProps = (state) => ({
  viewDetails: state.preSalesListReducer.viewDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewDetails);
